import(/* webpackMode: "eager" */ "/vercel/path0/app/api-docs/page.tsx");
